import { Box } from 'grommet';
import { base } from '@sdxcorp/sdx-dds-gui-lib';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

const {
  molecules: { TextTruncate },
} = base;

const ENV_TYPE = gql`
  query EnvType {
    data @rest(type: "", path: "env") {
      env
    }
  }
`;

const statusColors: Record<string, string> = {
  dx: '#5DB85D',
  tx: '#FEC653',
  mx: '#E84D47',
};

const EnvType = () => {
  const { t } = useTranslation();
  const { data: envData } = useQuery<{ data: { env: string } }>(ENV_TYPE, {
    errorPolicy: 'ignore',
  });

  const envType = envData?.data?.env?.toLocaleLowerCase();

  if (!envType || !['dx', 'tx', 'mx'].includes(envType)) {
    return null;
  }

  const envColor = statusColors[envType as string];

  return (
    <Box background={envColor} style={{ padding: '0 8px', borderRadius: '4px' }}>
      <TextTruncate testId="env-type" text={t(`header.envType.${envType}`)} style={{ color: '#FFFFFF' }} />
    </Box>
  );
};

export default EnvType;
